export default __webpack_public_path__ + "static/media/ManageOpsIcon.065643a7.svg";